import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";

import Download from "../../../components/admin/download";
import MusicPage from "../../../components/user/Music";
import StreamChart from "../../../components/admin/StreamChart";
import { musicService } from "../../../services";
import Spinner from "../../../components/UI/Spinner";
import ErrorModal from "../../../components/UI/Error";

const MusicViewPage = () => {
  const { id } = useParams();
  const [music, setMusic] = useState(null);
  const [streamChartData, setStreamChartData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  useEffect(() => {
    const fetchMusic = async () => {
      try {
        let musicResponse = await musicService.singleMusic(id);
        setMusic(musicResponse);

        let { streams } = musicResponse;
        const streamChartData = [
          // {
          //   key: "BMP",
          //   platform: "Boomplay",
          //   streams: streams.boomplay.stream || 0,
          // },
          {
            key: "APM",
            platform: "Apple Music",
            streams: streams?.appleMusic?.stream || 0,
          },
          // {
          //   key: "YTM",
          //   platform: "Youtube Music",
          //   streams: streams?.youtubeMusic.stream || 0,
          // },
          {
            key: "SFY",
            platform: "Spotify",
            streams: streams?.spotify.stream || 0,
          },
          {
            key: "AZM",
            platform: "Amazon Music",
            streams: streams?.amazonMusic.stream || 0,
          },
        ];
        setStreamChartData(streamChartData);
      } catch (error) {
        console.error("Error fetching music details:", error);
        setError(true);
      } finally {
        setLoading(false);
      }
    };
    fetchMusic();
  }, [id]);

  if (loading)
    return (
      <div className="grid place-content-center h-[60vh]">
        <Spinner />
      </div>
    );
  if (error)
    return (
      <ErrorModal
        isOpen={error}
        onClose={() => setError(false)}
        title={"Error Fetching Music"}
        message={
          "There is error while trying to fetch the music details. Please check your internet contivities and refresh this page to try again"
        }
      />
    );
const downloadUrl={
  audio:music.audio,
  image:music.image
}
  return (
    <MusicPage music={music} editMusic={`/admin/music/view/edit-music`} download={<Download downloadLink={downloadUrl}/>}>
      <StreamChart streamChartData={streamChartData} />
    </MusicPage>
  );
};

export default MusicViewPage;
